import { sanitizeObject } from "./sanitizeObject";

export const treatParams = <T extends object = any>(params: T) => {
  const request: T = {} as T;

  sanitizeObject<T>(params).forEach((val) => (request[val] = params[val]));

  return request;
};
